'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _KeepInMind = require('shared/components/KeepInMind');

var _Tabs = require('./Tabs');

var _Content = require('./Content');

var _selectors = require('./selectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  {
    "type": "job_match",
    "education": {
      "image": {
        "url": "http://placeimg.com/300/300/animals"
      }
    }
  }

  The sidebar module for the Job Description template.

  Most of the content is gleaned from the local store,
  with the exception of the education image, which
  can be passed from Craft.

  Another option would be to hard code this in React;
  makes no difference to me!
 */

function JobMatch(_ref) {
  var moduleClass = _ref.moduleClass,
      tabs = _ref.tabs,
      currentTab = _ref.currentTab,
      changeTab = _ref.changeTab,
      showMoreInterests = _ref.showMoreInterests,
      showMore = _ref.showMore,
      interests = _ref.interests,
      skills = _ref.skills,
      education = _ref.education;

  return _react2.default.createElement(
    'div',
    {
      className: 'type-job_match ' + moduleClass
    },
    _react2.default.createElement(_KeepInMind.KeepInMind, null),
    _react2.default.createElement(_Tabs.Tabs, {
      changeTab: changeTab,
      currentTab: currentTab,
      tabs: tabs
    }),
    _react2.default.createElement(_Content.Content, {
      currentTab: currentTab,

      interests: interests,
      skills: skills,

      showMore: showMore,
      showMoreInterests: showMoreInterests,

      education: education
    })
  );
}

exports.default = (0, _reactRedux.connect)(_selectors.mapStateToProps, _selectors.mapDispatchToProps)(JobMatch);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/JobMatch/JobMatch.jsx
// module id = 1199
// module chunks = 0